(function () {
    'use strict';

    window.GAEvent = {
        init: init,
        send: send,
        sendByElement: sendByElement,
        isPlugged: isPlugged
    };
    let defaultData = {
        eventCategory: '',
        eventAction: '',
        eventLabel: '',
        callback: null,
        timeout: 0
    };

    function init(element, eventName = 'click') {
        if (!element) {
            return;
        }

        element.addEventListener(eventName, onElementClick);
    }

    function send(data) {
        _send('event', data);
    }

    function sendByElement(element, callback, timeout) {
        if (!isElementAnalytics(element)) {
            return;
        }

        send({
            eventCategory: element.getAttribute('data-ga-event-category'),
            eventAction: element.getAttribute('data-ga-event-action'),
            eventLabel: element.getAttribute('data-ga-event-label'),
            callback: callback,
            timeout: timeout
        });
    }

    function _send(hitType, data) {
        if (!isPlugged()) {
            return;
        }

        data = mergeObjects(defaultData, data);
        let sendData = {
            hitType: hitType,
            eventCategory: data.eventCategory,
            eventAction: data.eventAction,
            eventLabel: data.eventLabel
        };

        if (typeof data.callback === 'function') {
            sendData.hitCallback = createFunctionWithTimeout(data.callback, data.timeout);
        }

        ga('send', sendData);
    }

    function isPlugged() {
        return typeof ga === 'function';
    }

    function isElementAnalytics(element) {
        return element.hasAttribute('data-send-ga-event');
    }

    function mergeObjects(target, source) {
        if (!target) {
            throw new TypeError('Cannot convert first argument to object');
        }

        let to = Object(target);
        let keysArray = Object.keys(Object(source));
        for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            let nextKey = keysArray[nextIndex];
            to[nextKey] = source[nextKey];
        }

        return to;
    }

    function createFunctionWithTimeout(callback, timeout) {
        let called = false;

        function fn() {
            if (!called) {
                called = true;
                callback();
            }
        }

        setTimeout(fn, timeout || 500);
        return fn;
    }

    function onElementClick(evt) {
        sendByElement(evt.currentTarget);
    }

})();